export const MOCK_MENUITEAM = {
    values: [{
        id: 'my-practice',
        name: 'My Practice',
        entitlements: [],
        children: [
            {
                id: 'lists',
                name: 'Lists',
                entitlements: [],
                children: [
                    {
                        id: 'households',
                        name: 'Households',
                        entitlements: []
                    },
                    {
                        id: 'clients',
                        name: 'Clients',
                        entitlements: [],
                        children: []
                    }
                ]
            },
            {
                id: 'details',
                name: 'Details',
                entitlements: [],
                children: [
                    {
                        id: 'holdings',
                        name: 'Holdings',
                        entitlements: [],
                        children: [
                            {
                                id: 'positions',
                                name: 'Positions',
                                entitlements: []
                            },
                            {
                                id: 'gains-losses',
                                name: 'Gains/Losses',
                                entitlements: []
                            }
                        ]
                    }
                ]
            }
        ]
    },

    {
        id: 'operations',
        name: 'Operations',
        entitlements: [],
        children: []
    },
    {
        id: 'analytics',
        name: 'Analytics & Reporting',
        entitlements: [],
        children: []
    }
    ]
};
